module.exports = __webpack_public_path__ + "img/list-icon.7ab63d70.png";